import styled from "styled-components";

export const StyledControlContainer = styled.div`
    padding-bottom: 5px;
`;